<template>
  <div class="base-data">
    <div class="base-data__title">
      Базовые данные
    </div>

    <div class="base-data__description">
      Учитываются данные только закрытых вакансий
    </div>

    <VDataTable
      v-if="props.items?.length > 0"
      :headers="props.headers"
      :items="itemsSorted"
      v-model="selected"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :pagination="false"
      @update:sort-by="sortBy = $event"
      @update:sort-desc="sortDesc = $event"
      maxHeight="270px"
    >
      <template #item.title="{item}">
        <p class="title" v-if="item.title">{{ item.title }}</p>
        <div v-else>-</div>
      </template>
      <template #item.time="{item}">
        <p class="time" v-if="item?.time">{{ item?.time?.toString()?.replace('.', ',') }} {{ declineDays(item?.time) }}</p>
        <div v-else>-</div>
      </template>
      <template #item.conversion_value="{item}">
        <p class="conversy" v-if="item.conversion_value">
          <div class="text-b">
            {{ formatNum(item.conversion_value) }}%
          </div>
          <span v-if="typeof item.conversion_delta !== 'undefined'" :style="getColor(item?.conversion_delta)">
          &nbsp; {{ formatNum(item.conversion_delta) }}%
        </span>
        </p>
        <div v-else>-</div>
      </template>
      <template #item.closed="{item}">
        <p class="conversy" v-if="item.closed_value">
          <div class="text-b">
            {{ formatNum(item.closed_value)}}%
          </div>
          <span v-if="item.closed_delta" :style="getColor(item?.closed_delta)">
          &nbsp; {{ formatNum(item.closed_delta) }}%
        </span>
        </p>
        <div v-else>-</div>
      </template>
    </VDataTable>

    <div v-if="props.items?.length > 0 && isVacancy" class="base-data__total">
      <div class="title">Средние значения</div>
      <div class="time" v-if="total?.average_time > 0">{{ total?.average_time?.toString()?.replace('.', ',') }} {{ declineDays(total?.average_time) }}</div>
      <div class="time" v-else>-</div>

      <div class="conversy">
        <div class="text-b">{{ formatNum(total?.average_conversion_value) }}%</div>
        <div :style="getColor(total?.average_conversion_delta)">
          &nbsp;{{ formatNum(total?.average_conversion_delta) }}%
        </div>
      </div>
    </div>

    <div v-if="props.items?.length > 0 && !isVacancy" class="base-data__total-closed">
      <div class="title">Средние значения</div>
        <div v-if="total?.average_time " class="time">{{ total?.average_time.toString()?.replace('.', ',') }} {{ declineDays(total?.average_time) }}</div>
        <div class="time" v-else>-</div>
      <div class="conversy">
        <div class="text-b">{{ formatNum(total?.average_conversion_value) }}</div>
        <div :style="getColor(total?.average_conversion_delta)">
          &nbsp;{{ formatNum(total?.average_conversion_delta) }}%
        </div>
      </div>
      <div class="closed">
        <div class="text-b">{{ formatNum(total?.average_closed_value) }}%</div>
        <div :style="getColor(total?.average_closed_delta)">
          &nbsp;{{ formatNum(total?.average_closed_delta)}}%
        </div>
      </div>
    </div>
    <div class="no-data" v-if="props.items?.length === 0">
      Нет данных
    </div>
  </div>
</template>
<script setup>
import {computed, ref} from "vue";
import {useRoute} from "vue-router";
import {declineDays, formatNum, getColor} from "@/utils";
import { SORT_CONFIG_BASE } from "@/constants";

const props = defineProps({
  items: [Object, Array],
  headers: [Object, Array],
  total: [Object, Array],
})

const route = useRoute();

const isVacancy = computed(() => {
  return route.query?.tabs === 'by-vacancies'
});

const selected = ref([])
const sortBy = ref('title')
const sortDesc = ref(false)

const itemsSorted = computed(() => {
  if (!sortBy.value || sortDesc.value === 'none') {
    return props.items
  }

  const config = SORT_CONFIG_BASE[sortBy.value]
  if (!config) {
    console.warn(`Unknown sort field: ${sortBy.value}`)
    return props.items
  }

  return [...props.items].sort((a, b) => {
    let valueA, valueB

    if (config.type === 'string') {
      valueA = a[config.field].toLowerCase()
      valueB = b[config.field].toLowerCase()
    } else {
      // Для вложенных объектов разбиваем путь к полю
      const fields = config.field.split('.')
      valueA = fields.reduce((obj, field) => obj[field], a)
      valueB = fields.reduce((obj, field) => obj[field], b)
    }

    if (valueA < valueB) {
      return sortDesc.value ? 1 : -1
    }
    if (valueA > valueB) {
      return sortDesc.value ? -1 : 1
    }
    return 0
  })
})
</script>
<style lang="scss" scoped>
.base-data {
  background-color: white;
  border-radius: 16px;
  padding: 24px;
  max-height: 441px;

  &__title {
    font-weight: 600;
    font-size: 20px;
    margin-bottom: 8px;
  }

  &__description {
    font-size: 14px;
    margin-bottom: 20px;
    color: $dark-blue;
  }

  &__total {
    display: flex;
    font-size: 14px;
    padding: 12px 24px;
    background-color: $light;
    border: 1px solid $grey-main;
    border-radius: 16px;
    margin-top: 12px;
    height: 41px;

    .title {
      width: 410px;
      font-weight: 500;
      font-size: 14px;
    }

    .time {
      width: 187px;
      font-weight: 600;
      font-size: 14px;
    }

    .conversy {
      width: auto;
      display: flex;
      font-size: 12px;
      align-items: center;
    }
  }

  &__total-closed {
    display: flex;
    font-size: 14px;
    padding: 12px 24px;
    background-color: $light;
    border: 1px solid $grey-main;
    border-radius: 16px;
    margin-top: 12px;


    .title {
      width: 508px;
      font-weight: 500;
      font-size: 14px;
    }

    .time {
      width: 187px;
      font-weight: 600;
      font-size: 14px;
    }

    .conversy {
      width: 190px;
      display: flex;
      font-size: 12px;
      align-items: center;
    }

    .closed {

      width: 50px;
      display: flex;
      font-size: 12px;
      align-items: center;
    }
  }

  .conversy {
    display: flex;
    font-size: 12px;
    align-items: center;
  }


  .time {
    font-weight: 600;
    font-size: 14px;
  }

  .text-b {
    font-weight: 600;
    font-size: 14px !important;
  }

  .title {
    font-size: 14px;
  }

  .no-data {
    height: 326px;
    width: 100%;
    color: $gray;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 20px;
    text-align: center;
    border: 1px solid rgba(228, 231, 238, 1);
    border-radius: 12px;
  }
}
</style>